var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
// import { DefaultComponentProps } from "@mui/material/OverridableComponent";
import MuiFormControlLabel from '@mui/material/FormControlLabel';
import { FormHelperText } from '../form-helper-text';
import { styled } from '../../styled';
import { formControlLabelClasses, formControlLabelComponentName, getFormControlLabelUtilityClass, } from './form-control-label-classes';
import clsx from '../../utils/clsx';
import { useMergedClasses } from '../../styles/classes';
var Root = styled(MuiFormControlLabel, {
    name: formControlLabelComponentName,
    slot: 'Root',
})(function (_a) {
    var _b;
    var _c;
    var theme = _a.theme, ownerState = _a.ownerState;
    return (_b = {
            paddingLeft: theme.spacing(1),
            paddingTop: theme.spacing(1),
            paddingBottom: theme.spacing(1),
            alignItems: 'flex-start',
            width: ownerState.noWrap ? '100%' : undefined
        },
        _b["& .".concat(formControlLabelClasses.label)] = {
            lineHeight: theme.typography.pxToRem((_c = ownerState.height) !== null && _c !== void 0 ? _c : 18),
            minWidth: ownerState.noWrap ? 0 : undefined, // prevents overflow of parent flex container
        },
        _b);
});
var Container = styled('div', {
    name: formControlLabelComponentName,
    slot: 'Container',
})(function (_a) {
    var theme = _a.theme;
    return ({
        marginLeft: theme.spacing(1),
    });
});
var LabelContainer = styled('span', {
    name: formControlLabelComponentName,
    slot: 'LabelContainer',
})(function (_a) {
    var _b;
    var theme = _a.theme, ownerState = _a.ownerState;
    return ({
        display: 'flex',
        alignItems: 'flex-start',
        minHeight: theme.typography.pxToRem((_b = ownerState.height) !== null && _b !== void 0 ? _b : 18),
    });
});
var SpanLabel = styled('span', {
    name: formControlLabelComponentName,
    slot: 'SpanLabel',
})({
    flex: 1,
});
var Decoration = styled('span', {
    name: formControlLabelComponentName,
    slot: 'Decoration',
})({
    marginLeft: 8,
    flexShrink: 0,
});
var HelperText = styled(FormHelperText, {
    name: formControlLabelComponentName,
    slot: 'HelperText',
})(function (_a) {
    var _b;
    var theme = _a.theme, ownerState = _a.ownerState;
    return (__assign(__assign({}, (ownerState.noWrap && {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
    })), { marginTop: theme.spacing(0.5), lineHeight: theme.typography.pxToRem((_b = ownerState.height) !== null && _b !== void 0 ? _b : 18) }));
});
export var FormControlLabel = React.forwardRef(function (props, ref) {
    var label = props.label, noWrap = props.noWrap, className = props.className, helperText = props.helperText, _a = props.HelperTextProps, HelperTextProps = _a === void 0 ? {} : _a, decoration = props.decoration, height = props.height, rootProps = __rest(props, ["label", "noWrap", "className", "helperText", "HelperTextProps", "decoration", "height"]);
    var classes = useMergedClasses(formControlLabelClasses, getFormControlLabelUtilityClass, props.classes);
    var ownerState = {
        noWrap: noWrap,
        height: height,
    };
    var controlLabel = (React.createElement(Container, { className: classes.container },
        React.createElement(LabelContainer, { ownerState: ownerState, className: classes.labelContainer },
            React.createElement(SpanLabel, { className: classes.controlLabel }, label),
            !!decoration && React.createElement(Decoration, { className: classes.decoration }, decoration)),
        !!helperText && (React.createElement(HelperText, __assign({ ownerState: ownerState, className: classes.helperText }, HelperTextProps), helperText))));
    return (React.createElement(Root, __assign({ label: controlLabel, ownerState: ownerState, className: clsx(className, classes.root, classes.label) }, rootProps, { ref: ref })));
});
